
















import { Component } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import EntryLayout from '@/components/entry/Layout.vue'
import RecruitCard from "@/components/recruits/Card.vue"
import axios from "axios"
import Recruit, {IRecruit} from "@/models/Recruit"
import {apiV1RecruitsFavoritesPath} from "@/rails/routes"

@Component({
  components: {
    EntryLayout,
    RecruitCard
  }
})
export default class FavoritesIndex extends VueBase {
  recruits: Array<Recruit> = []

  async mounted(): Promise<void> {
    this.loading = true
    const res = await axios.get<Array<IRecruit>>(apiV1RecruitsFavoritesPath())
    this.recruits = res.data.map(r => new Recruit(r))
    this.loading = false
  }

  showRecruit(): void {
    window.open(this.settings.site.recruit, '_blank')
  }

  showTop(): void {
    window.open(this.settings.site.top, '_blank')
  }
}
